import Lara from "@/presets/lara";

const dialogDefaultPt = Lara.dialog;
const buttonDefaultPt = Lara.button;

export const dialogPt = {
  root: (options) => ({
    class: [...dialogDefaultPt.root(options).class, "!max-h-[90vh]"],
  }),
  // The rule keeps the white header from reading as continuous with a white page
  // rendered against the body's backdrop.
  header: {
    class: [...dialogDefaultPt.header.class, "rounded-t-xl !bg-white", "!border-b !border-gray-175"],
  },
  // The body owns its own padding so the toolbar can sit flush against the header.
  content: (options) => ({
    class: [...dialogDefaultPt.content(options).class, "!p-0 !overflow-hidden !flex !flex-col"],
  }),
  // Lara centres the footer; the design puts the action on the right. The rule needs the
  // important flag to beat the preset's own border-t-0.
  footer: {
    class: [
      ...dialogDefaultPt.footer.class,
      "rounded-b-xl !bg-white !justify-end !pt-4",
      "!border-t !border-gray-175",
    ],
  },
  // The dialog focuses this on open, so Lara's always-on focus ring renders as a
  // heavy coloured circle. Dropping it for focus-visible keeps the keyboard cue
  // without showing it to every mouse user.
  closeButton: {
    class: [
      ...dialogDefaultPt.closeButton.class.filter((className) => !className.startsWith("focus:ring")),
      "!rounded-md !w-9 !h-9 !border !border-gray-175 !text-indigo-base hover:!bg-gray-125",
      "focus-visible:ring-2 focus-visible:ring-gray-400",
    ],
  },
  closeButtonIcon: {
    class: [...dialogDefaultPt.closeButtonIcon.class, "!w-4 !h-4"],
  },
};

// The zoom controls read as one segmented pill, so they drop their own borders
// and background and take them from the wrapper instead.
const outlinedControl = ["!bg-transparent !border-0 !text-indigo-base hover:!bg-gray-125"];

export const zoomButtonPt = {
  root: (options) => ({
    class: [...buttonDefaultPt.root(options).class, ...outlinedControl, "!w-6 !h-6 !p-0 !justify-center"],
  }),
};

export const resetButtonPt = {
  root: (options) => ({
    class: [
      ...buttonDefaultPt.root(options).class,
      "!h-8 !px-3 !text-xs !font-bold !bg-transparent !text-indigo-base !border !border-gray-175 hover:!bg-gray-125",
    ],
  }),
};
